import { NS } from "./namespaces";

/**
 * Returns true if the supplied element is a Panel Designer component, otherwise false.
 * @param el The element to check.
 */
export function isPDComponentElement(el: SVGGraphicsElement) {
    if (!el) {
        return false;
    }

    const tagName = el.tagName.toLowerCase();
    return (tagName === "g" || tagName === "use") && el.hasAttribute("zaa:component-reference");
}

/**
 * Starts a browser download of the supplied content.
 * @param fileName The file name of the downloaded content.
 * @param content The file content.
 * @param mimeType The mime type of the content.
 */
export function startDownloadContent(fileName: string, content: any, mimeType: string) {
    const blobBuilder = (window as any).BlobBuilder || (window as any).WebKitBlobBuilder;

    const a = window.document.createElement("a");
    a.download = fileName;

    let blob = null;
    if (blobBuilder) {
        blob = new blobBuilder();
        blob.append(content);
        a.href = window.URL.createObjectURL(blob.getBlob(mimeType));
    } else {
        blob = new Blob([content], { "type": mimeType});
        a.href = window.URL.createObjectURL(blob);
    }

    a.dataset.downloadurl = [mimeType, a.download, a.href].join(":");
    a.click();
    a.remove();
}

/**
 * Starts a browser download of the supplied base64 encoded.
 * @param fileName The file name of the downloaded content.
 * @param content The file content encoded as base64.
 * @param mimeType The mime type of the content.
 */
export function startDownloadBase64EncodedContent(fileName: string, content: any, mimeType: string) {
    const a = window.document.createElement("a");
    a.download = fileName;
    a.href = `data:${mimeType};base64,${content}`;
    a.click();
    a.remove();
}

export function getCanvasDpi() {
    let dpi = 72.0;
    const dpiStr = document.getElementById("svgcontent").getAttribute("zaa:dpi");
    if (dpiStr) {
        const dpiNum = parseFloat(dpiStr);
        if (!isNaN(dpiNum)) {
            dpi = dpiNum;
        }
    }
    return dpi;
}

export function camelCaseToKebabCase(str: string) {
    return str.replace(/[A-Z]+(?![a-z])|[A-Z]/g, ($, ofs) => (ofs ? "-" : "") + $.toLowerCase());
}

export function kebabCaseToCamelCase(str: string) {
    return str.replace(/-./g, x => x[1].toUpperCase());
}
